const values = [
  {
    icon: "ri-heart-3-line",
    title: "热爱与尊重",
    desc: "我们尊重每一位创作者的付出，所有作品均标注作者与来源，鼓励正向二创文化。",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容规范",
    desc: "严格的内容审核与版权规范，让读者安心阅读，让创作者放心投稿。",
  },
  {
    icon: "ri-group-line",
    title: "社区共建",
    desc: "打造同好交流的温暖社区，阅读、追更、交流一气呵成，一起为热爱的IP应援。",
  },
  {
    icon: "ri-plant-line",
    title: "持续更新",
    desc: "保持稳定更新频率，每周都有新作与连载进度，不错过每一个精彩篇章。",
  },
];

const testimonials = [
  {
    name: "夏目同学",
    role: "火影同人读者",
    quote: "终于找到一个能把火影同人按分类整理好的地方了，追更超方便，质量也高。",
    avatar: "ri-user-heart-line",
  },
  {
    name: "一只橘猫",
    role: "咒回创作者",
    quote: "投稿审核很顺利，上线后收到好多读者的喜欢，创作动力直接拉满！",
    avatar: "ri-user-smile-line",
  },
  {
    name: "热血球门",
    role: "排球同人读者",
    quote: "排球少年的同人真的宝藏，每天蹲更新，页面也很好看，爱了爱了。",
    avatar: "ri-user-star-line",
  },
];

export default function AboutSection() {
  return (
    <section
      id="about"
      className="w-full bg-background-900/60 py-16 md:py-20"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-accent-400">
              <i className="ri-information-line"></i>
              ABOUT US
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              关于我们
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              「同人漫研」是一个专注热门IP二创的同人漫画聚合与交流平台。我们相信，每一份同人创作背后，都是对原作最真挚的热爱。我们为创作者提供展示与成长的舞台，为读者提供便捷、优质的阅读体验。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              从火影忍者的羁绊到海贼王的冒险，从咒术回战的宿命到鬼灭之刃的守护，再到排球少年的热血，我们持续整理、推荐与更新，让经典IP的二创宇宙触手可及。
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="rounded-lg bg-background-800/60 p-5 ring-1 ring-background-200/50"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500/15 text-lg text-accent-400">
                    <i className={v.icon}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                    {v.title}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">
                    {v.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-chat-quote-line text-accent-400"></i>
              读者与创作者口碑
            </h3>
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-lg bg-background-800/60 p-6 ring-1 ring-background-200/50"
              >
                <blockquote className="text-sm leading-relaxed text-foreground-700">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/15 text-lg text-primary-400">
                    <i className={t.avatar}></i>
                  </span>
                  <div>
                    <div className="text-sm font-bold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}